import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Permissions } from "src/app/core/services/permissions";
import { UserService } from "src/app/core/services/user.service";
import { ISidebarMenu } from "../interfaces/iSidebarMenu";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  translationModulesEnum = TranslationModuleEnum;

  menuItems: any[];
  claims = [];
  year = 2024;

  constructor(private userSer: UserService, private router: Router) {}

  buildMenu() {
    // Get Users Claims
    let claims = this.userSer.getCurrentUserClaims();
    if (claims) {
      // console.log(claims)
      // Update once backend returns claims
      claims.push("ManageAll");
      if (!claims) {
        return;
      }

      this.menuItems = [
        {
          id: 1,
          index: 1,
          translationKey: "shared.dashboard",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bxs-dashboard",
          claims: ["ManageAll"],
          visible: true,
          children: [
            {
              id: 11,
              index: 1,
              translationKey: "shared.dashboard",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bxs-dashboard",
              routerLink: "/dashboard",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 5,
          index: 5,
          translationKey: "shared.admin.moduleTitle",
          translationModuleEnum: this.translationModulesEnum.shared,
          // name: {
          //   en: "Admin",
          //   ar: "الادارة",
          // },
          icon: "bx bx-user",
          claims: this.getAllowShowAdmin(claims) ? ["ManageAll"] : [],
          visible: true,
          children: [
            {
              id: 51,
              index: 1,
              translationKey: "shared.admin.users",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Users",
              //   ar: "المستخدمون",
              // },
              icon: "bx bx-user",
              routerLink: "/users",
              claims: [Permissions.UserManagement.Users.view],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 52,
              index: 2,
              translationKey: "shared.admin.roles",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Roles",
              //   ar: "الأدوار",
              // },
              icon: "bx bx-check-shield",
              routerLink: "/roles",
              claims: [Permissions.UserManagement.Roles.view],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 53,
              index: 3,
              translationKey: "shared.admin.committees",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Committees",
              //   ar: "اللجان",
              // },
              icon: "bx bx-group",
              routerLink: "/committees",
              claims: [Permissions.UserManagement.Committees.view],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 54,
              index: 4,
              translationKey: "shared.admin.groups",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Groups",
              //   ar: "المجموعات",
              // },
              icon: "bx bx-group",
              routerLink: "/groups",
              claims: [Permissions.UserManagement.Groups.view],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 55,
              index: 5,
              translationKey: "shared.admin.delegations",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Delegations",
              //   ar: "التفويضات",
              // },
              icon: "bx bx-user",
              routerLink: "/delegations",
              claims: [Permissions.WorkFlow.ManageDelegations],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 56,
              index: 6,
              translationKey: "shared.admin.process",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Process",
              //   ar: "المخططات",
              // },
              icon: "bx bx-user",
              routerLink: "/process",
              claims: [Permissions.WorkFlow.ManageProcess],
              visible: true,
              hasCounter: false,
              children: [],
            },
            // {
            //   id: 57,
            //   index: 7,
            //   translationKey: "shared.admin.lookupManagement",
            //   translationModuleEnum: this.translationModulesEnum.shared,
            //   // name: {
            //   //   en: "Lookup Management",
            //   //   ar: "إدارة القيم",
            //   // },
            //   icon: "bx bxs-notepad",
            //   routerLink: "/lookups",
            //   claims: [Permissions.UserManagement.Groups.view],
            //   visible: true,
            //   hasCounter: false,
            //   children: [],
            // },
            {
              id: 57,
              index: 8,
              translationKey: "shared.admin.cmsManagement",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "CMS Management",
              //   ar: "إدارة البيانات",
              // },
              icon: "isax isax-firstline",
              routerLink: "/cms-management",
              claims: [Permissions.CMS.View],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 58,
              index: 9,
              translationKey: "shared.admin.mediaCenter",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bxs-image",
              routerLink: "/media-center",
              claims: [Permissions.MediaCenter.view],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 59,
              index: 10,
              translationKey: "shared.admin.settings",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Settings",
              //   ar: "الإعدادات",
              // },
              icon: "bx bx-cog",
              routerLink: "/settings",
              claims: [Permissions.Settings.ListSettings],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 60,
              index: 11,
              translationKey: "shared.admin.AuthenticationAndOtpLogs",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Settings",
              //   ar: "الإعدادات",
              // },
              icon: "bx bx-list-ul",
              routerLink: "/authentication-logs-dashboard",
              claims: [Permissions.Settings.ListSettings],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 8,
          index: 8,
          translationKey: "shared.events.events",
          translationModuleEnum: this.translationModulesEnum.shared,
          // name: {
          //   en: "Events",
          //   ar: "الأحداث",
          // },
          icon: "bx bxs-calendar-event",
          claims: [Permissions.Events.ListEvent],
          visible: true,
          children: [
            {
              id: 71,
              index: 1,
              translationKey: "shared.events.eventsList",
              translationModuleEnum: this.translationModulesEnum.shared,
              // name: {
              //   en: "Events List",
              //   ar: "قائمة الأحداث",
              // },
              icon: "bx bx-list-ul",
              routerLink: "/events/list",
              claims: [Permissions.Events.ListEvent],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 72,
              index: 2,
              translationKey: "shared.events.eventRequests",
              translationModuleEnum: this.translationModulesEnum.shared,

              icon: "bx bx-list-ul",
              routerLink: "/events/requests",
              claims: [Permissions.Events.ManageRequests],
              // claims: [Permissions.Events.ManageRequests],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 73,
              index: 3,
              translationKey: "shared.new-eventsdashboard",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bxs-dashboard",
              routerLink: "/events/events-dashboard",
              claims: [Permissions.Events.ViewDashboard],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 66,
          index: 9,
          translationKey: "shared.jobs.jobs",
          translationModuleEnum: this.translationModulesEnum.shared,

          icon: "bx bxs-briefcase",
          claims: [Permissions.Jobs.ListJobs],
          visible: true,
          children: [
            {
              id: 73,
              index: 1,
              translationKey: "shared.jobs.jobsList",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/jobs/list",
              claims: [Permissions.Jobs.ListJobs],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 74,
              index: 1,
              translationKey: "shared.new-dashboard",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bxs-dashboard",
              routerLink: "/jobs/jobs-dashboard",
              claims: [Permissions.Jobs.ViewDashboard],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 666,
          index: 99,
          translationKey: "shared.volunteer.volunteer",
          translationModuleEnum: this.translationModulesEnum.shared,

          icon: "bx bxs-heart-circle",
          claims: [Permissions.Volunteers.ListVolunteers],
          visible: true,
          children: [
            {
              id: 727,
              index: 19,
              translationKey: "shared.volunteer.vol-Lst",
              translationModuleEnum: this.translationModulesEnum.shared,

              icon: "bx bx-list-ul",
              routerLink: "/volunteers/list",
              claims: [Permissions.Volunteers.ListVolunteers],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 777,
          index: 10,
          translationKey: "shared.membershipManagement",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bxs-user-badge",
          claims: [Permissions.Membership.MembershipModule],
          visible: true,
          hasCounter: false,
          children: [
            {
              id: 7771,
              index: 1,
              translationKey: "shared.packages",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/membership/packages",
              claims: [Permissions.Membership.Packages.List],
              visible: true,
              hasCounter: false,
              children: [],
            },

            {
              id: 7772,
              index: 2,
              translationKey: "shared.requests",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/membership/requests",
              claims: [
                Permissions.Membership.MembershipManagement.RequestsList,
              ],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 7773,
              index: 3,
              translationKey: "shared.management",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/membership/management",
              claims: [
                Permissions.Membership.MembershipManagement
                  .MembershipManagementRequests,
              ],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 7774,
              index: 4,
              translationKey: "shared.transferRequests",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/membership/transferRequests",
              claims: [Permissions.Membership.TransferRequests.Review],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 7775,
              index: 5,
              translationKey: "shared.members",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/membership/members",
              claims: [Permissions.Membership.Members.List],

              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 9,
          index: 11,
          translationKey: "shared.booking",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bxs-calendar",
          claims: [
            Permissions.Booking.requests.list ||
              Permissions.Booking.assets.list,
          ],
          visible: true,
          hasCounter: false,
          children: [
            {
              id: 91,
              index: 1,
              translationKey: "shared.bookingRequests",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/booking/requests",
              claims: [Permissions.Booking.requests.list],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 92,
              index: 2,
              translationKey: "shared.bookingAssets",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/booking/assets",
              claims: [Permissions.Booking.assets.list],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 10,
          index: 10,
          translationKey: "shared.competitions",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bxs-trophy",
          claims: [Permissions.Competition.GetCompetitionList],
          visible: true,
          hasCounter: false,
          children: [
            {
              id: 101,
              index: 1,
              translationKey: "shared.competitionList",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/competition/list",
              claims: [Permissions.Competition.GetCompetitionList],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 102,
              index: 1,
              translationKey: "shared.competitionUpdateList",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/competition/updateList",
              claims: [Permissions.Competition.GetCompetitionList],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 18,
          index: 10,
          translationKey: "shared.sheikh-sultan-competitions",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bxs-trophy",
          claims: [Permissions.Competition.GetCompetitionList],
          visible: true,
          hasCounter: false,
          children: [
            {
              id: 101,
              index: 1,
              translationKey: "shared.competitionList",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/new-competition/list",
              claims: [Permissions.Competition.GetCompetitionList],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 102,
              index: 1,
              translationKey: "shared.assignCoordinatorsToOrganizations",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/new-competition/assign-coordinators",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          index: 12,
          id: 12,
          translationKey: "shared.satisfactionSurvey",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bx-poll",
          claims: ["ManageAll"],
          visible: true,
          hasCounter: false,
          children: [
            {
              id: 121,
              index: 1,
              translationKey: "shared.csatConfiguration",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-bar-chart-alt-2",
              routerLink: "/survey",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 122,
              index: 2,
              translationKey: "shared.satisfactionConfiguration",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-slider-alt",
              routerLink: "/survey/satisfaction-config",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          index: 19,
          id: 19,
          translationKey: "shared.satisfactionAndSharing",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bx-happy-alt",
          claims: ["ManageAll"],
          visible: true,
          hasCounter: false,
          children: [
            {
              id: 191,
              index: 1,
              translationKey: "shared.executiveView",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bxs-dashboard",
              routerLink: "/satisfaction-sharing/executive",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 192,
              index: 2,
              translationKey: "shared.entityView",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-building",
              routerLink: "/satisfaction-sharing/entity",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 193,
              index: 3,
              translationKey: "shared.detailedReport",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/satisfaction-sharing/detail",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 194,
              index: 4,
              translationKey: "shared.activitySharing",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-share-alt",
              routerLink: "/satisfaction-sharing/sharing",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          index: 13,
          id: 13,
          translationKey: "shared.donations",
          translationModuleEnum: this.translationModulesEnum.shared,
          icon: "bx bx-home-heart",
          claims: [
            Permissions.Donations.FunboxManagement.list ||
              Permissions.Donations.GiftCardCategory.list ||
              Permissions.Donations.GiftCardTemplate.list ||
              Permissions.Donations.donationsReport.list,
          ],
          visible: true,
          hasCounter: false,
          children: [
            {
              index: 1,
              id: 131,
              translationKey: "shared.fundBoxes",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/donations/fundboxes-management",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              index: 2,
              id: 132,
              translationKey: "shared.giftCaredCategories",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/donations/gift-card-categories",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              index: 3,
              id: 133,
              translationKey: "shared.giftCardTempalates",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-list-ul",
              routerLink: "/donations/gift-card-templates",
              claims: ["ManageAll"],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 14,
          index: 14,
          translationKey: "shared.loyalty",
          translationModuleEnum: this.translationModulesEnum.shared,
          name: {
            en: "Loyalty",
            ar: "نظام الولاء",
          },
          icon: "bx bx-gift",
          new_icon: "loyalty",

          claims: [Permissions.Loyalty.LoyaltySettingsLoyaltyModule],
          visible: true,
          children: [
            {
              id: 501,
              index: 1,
              translationKey: "shared.replace-requests",
              translationModuleEnum: this.translationModulesEnum.shared,
              name: {
                en: "Users",
                ar: "طلبات الإستبدال",
              },
              icon: "bx bx-user",
              new_icon: "docs",

              routerLink: "/loyalty/replace-requests",
              claims: [Permissions.Loyalty.OrderModule],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 502,
              index: 2,
              translationKey: "shared.gift-settings",
              translationModuleEnum: this.translationModulesEnum.shared,
              name: {
                en: "Roles",
                ar: "إدارة إعدادات الولاء",
              },
              icon: "bx bx-cog",
              new_icon: "discover_tune",

              routerLink: "/loyalty/settings",
              claims: [Permissions.Loyalty.LoyaltySettingsRead],
              visible: true,
              hasCounter: false,
              children: [],
            },

            {
              id: 503,
              index: 4,
              translationKey: "shared.manage-gifts",
              translationModuleEnum: this.translationModulesEnum.shared,
              name: {
                en: "Groups",
                ar: "إدارة الهدايا والمكافئات",
              },
              icon: "bx bx-group",
              new_icon: "featured_seasonal_and_gifts",
              routerLink: "/loyalty/manage-gifts",
              claims: [Permissions.Loyalty.GiftModule],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 504,
              index: 5,
              translationKey: "shared.report-gifts",
              translationModuleEnum: this.translationModulesEnum.shared,
              name: {
                en: "Groups",
                ar: "التقارير",
              },
              icon: "bx bx-group",
              new_icon: "lab_profile",
              routerLink: "/loyalty/gifts-report",
              claims: [Permissions.Loyalty.DashboardRead],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 505,
              index: 6,
              translationKey: "shared.loyalty-attendance",
              translationModuleEnum: this.translationModulesEnum.shared,
              name: {
                en: "Groups",
                ar: "التقارير",
              },
              new_icon: "article_person",

              icon: "bx bx-group",
              routerLink: "/loyalty/attendance",
              claims: [Permissions.Loyalty.LoyaltyAttendanceModule],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 505,
              index: 6,
              translationKey: "shared.loyalty-points-report",
              translationModuleEnum: this.translationModulesEnum.shared,
              new_icon: "forms_add_on",

              name: {
                en: "Groups",
                ar: "التقارير",
              },
              icon: "bx bx-group",
              routerLink: "/loyalty/points-report",
              claims: [Permissions.Loyalty.LoyaltyAttendanceModule],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 15,
          index: 15,
          translationKey: "shared.CentersManagments",
          translationModuleEnum: this.translationModulesEnum.shared,
          name: {
            en: "Centers Managments",
            ar: " ادارة المراكز",
          },
          icon: "bx bx-gift",
          new_icon: "host",

          claims: [Permissions.Loyalty.OrganizationCenterModule],
          visible: true,
          children: [
            {
              id: 532,
              index: 2,
              translationKey: "shared.view-centers",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-cog",
              new_icon: "host",
              routerLink: "/centers/list",
              claims: [Permissions.Loyalty.OrganizationCenterRead],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 16,
          index: 16,
          translationKey: "shared.CardsManagments",
          translationModuleEnum: this.translationModulesEnum.shared,
          name: {
            en: "Cards Managments",
            ar: " ادارة البطاقات",
          },
          icon: "bx bx-gift",
          new_icon: "nfc",

          claims: [Permissions.Loyalty.NFCMembershipModule],
          visible: true,
          children: [
            {
              id: 702,
              index: 2,
              translationKey: "shared.CardsManagments",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-cog",
              new_icon: "nfc",
              routerLink: "/nfc/cards",
              claims: [Permissions.Loyalty.NFCMembershipRead],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
        {
          id: 17,
          index: 17,
          translationKey: "shared.ContentManagments",
          translationModuleEnum: this.translationModulesEnum.shared,
          name: {
            en: "Content Managments",
            ar: " ادارة المحتوى",
          },
          icon: "bx bx-grid",
          // claims: [Permissions.ContentManagement.view],
          claims: [90000],
          visible: true,
          children: [
            // {
            //   id: 1701,
            //   index: 1,
            //   translationKey: "shared.entities",
            //   translationModuleEnum: this.translationModulesEnum.shared,
            //   icon: "bx bx-building",
            //   routerLink: "/content-management/entities",
            //   // claims: [Permissions.ContentManagement.Entities.View],
            //   claims: [90000],
            //   visible: true,
            //   hasCounter: false,
            //   children: [],
            // },
            {
              id: 1702,
              index: 2,
              translationKey: "shared.servicesManage",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-cog",
              routerLink: "/content-management/services",
              // claims: [Permissions.ContentManagement.Services.View],
              claims: [90000],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 1703,
              index: 3,
              translationKey: "shared.booking",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-calendar-check",
              routerLink: "/content-management/booking",
              // claims: [Permissions.ContentManagement.Booking.View],
              claims: [90000],
              visible: true,
              hasCounter: false,
              children: [],
            },
            {
              id: 1704,
              index: 4,
              translationKey: "shared.membership",
              translationModuleEnum: this.translationModulesEnum.shared,
              icon: "bx bx-user-circle",
              routerLink: "/content-management/membership",
              // claims: [Permissions.ContentManagement.Membership.View],
              claims: [90000],
              visible: true,
              hasCounter: false,
              children: [],
            },
          ],
        },
      ];

      let menus;

      // Filter Menu Items allowed for user
      menus = this.menuItems
        .filter((item: any) => {
          // Filter based on claims and visibility
          return (
            item.claims.some((claim: any) => claims.includes(claim)) &&
            item.visible
          );
        })
        .sort((a, b) => a.index - b.index);
      // console.log(menus)
      // Filter and sort children items
      menus.forEach((menu: any) => {
        menu.children = menu.children
          .filter((child: any) => {
            // Filter based on claims and visibility
            return (
              child.claims.some((claim: any) => claims.includes(claim)) &&
              child.visible
            );
          })
          .sort((a: any, b: any) => a.index - b.index);

        // Filter and sort grandchildren items
        menu.children.forEach((child: any) => {
          child.children = child.children
            .filter((grandchild: any) => {
              // Filter based on claims and visibility
              return (
                grandchild.claims.some((claim: any) =>
                  claims.includes(claim)
                ) && grandchild.visible
              );
            })
            .sort((a: any, b: any) => a.index - b.index);
        });
      });

      // console.log(menus)
      return menus;
    }
  }

  userId = localStorage.getItem("$EPPM$userId");
  navigateToFirstMenu() {
    const menu = this.buildMenu();

    if (menu) {
      const firstCategory = menu[0];
      const firstMenu = firstCategory?.children[0];

      this.router.navigateByUrl(firstMenu.routerLink);
    } else {
      this.router.navigateByUrl("/login");
    }
  }

  getAllowShowAdmin(claims): boolean {
    if (claims)
      return (
        claims.includes(Permissions.UserManagement.Users.view) ||
        claims.includes(Permissions.UserManagement.Roles.view) ||
        claims.includes(Permissions.UserManagement.Committees.view) ||
        claims.includes(Permissions.UserManagement.Groups.view) ||
        claims.includes(Permissions.WorkFlow.ManageDelegations) ||
        claims.includes(Permissions.WorkFlow.ManageProcess) ||
        claims.includes(Permissions.CMS.View) ||
        claims.includes(Permissions.MediaCenter.view) ||
        claims.includes(Permissions.Settings.ListSettings)
      );
    else return true;
  }

  getAllowShowPerformance(claims): boolean {
    if (claims)
      return (
        claims.includes(Permissions.Performance.Dashboard.View) ||
        claims.includes(Permissions.Performance.Scorecard.Create) ||
        claims.includes(Permissions.Performance.Scorecard.GetById) ||
        claims.includes(Permissions.Performance.Scorecard.MyActions) ||
        claims.includes(Permissions.Performance.Scorecard.Status) ||
        claims.includes(Permissions.Performance.Scorecard.Submit) ||
        claims.includes(Permissions.Performance.Scorecard.Update) ||
        claims.includes(Permissions.Performance.Goal.Add) ||
        claims.includes(Permissions.Performance.Goal.Edit) ||
        claims.includes(Permissions.Performance.Goal.Delete) ||
        claims.includes(Permissions.Performance.Scorecard_Submission.View) ||
        claims.includes(Permissions.Performance.Scorecard_Settings.View)
      );
    else return true;
  }

  navigateToSurvey() {
    this.router.navigateByUrl("/survey");
    return;
    this.userSer.generateSsoToken().subscribe(
      (response: any) => {
        window.open(
          `${environment.surveyServerUrl}?ssoToken=${response.data}`,
          "_self"
        );
      },
      (error: any) => {
        console.error("Failed to get survey URL", error);
      }
    );
  }
}
